import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageEntitiesComponent } from './components/manage-entities/manage-entities.component';

const routes: Routes = [
  {
    path: '',
    component: ManageEntitiesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageEntitiesRoutingModule {}
